import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import AppTextInput from '../../shared/components/app-text-input/AppTextInput';
import AppButton from '../../shared/components/app-button/AppButton';
import AppLink from '../../shared/components/app-link/AppLink';
import { forgotPasswordApi } from '../../api/loginApi';

function ForgotPassword({ onShowForm, onLoading, onAlert }) {
  const intl = useIntl();
  const [userId, setUserId] = useState('');
  const [validationError, setValidationError] = useState(false);

  const formattedMessage = (message) => {
    return intl.formatMessage({ id: message });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (userId === '') {
      setValidationError(true);
    } else {
      onLoading(true);
      setValidationError(false);
      const response = await forgotPasswordApi(userId);
      if (response) {
        if (response.ApiStatus) {
          if (response.ApiStatus.Status === 'OK') {
            onAlert({
              variant: 'success',
              title: formattedMessage('forgot_password_link'),
              description: formattedMessage('email_with_password_alert'),
            });
            setUserId('');
          } else {
            onAlert({
              variant: 'error',
              title: formattedMessage('forgot_password_link'),
              description: response.ApiStatus.Message,
            });
          }
        } else if (response.Root) {
          if (response.Root.Status === 'OK') {
            onAlert({
              variant: 'success',
              title: formattedMessage('forgot_password_link'),
              description: formattedMessage('email_with_password_alert'),
            });
          } else {
            onAlert({
              variant: 'error',
              title: formattedMessage('forgot_password_link'),
              description: response.Root.Message,
            });
          }
        }
      } else {
        onAlert({
          variant: 'error',
          title: formattedMessage('forgot_password_link'),
          description: formattedMessage('failed_request_alert'),
        });
      }
      onLoading(false);
    }
  };

  return (
    <form className="login-form d-flex flex-column flex-1">
      <div className="login-form_title">Forgot Password?</div>
      <div className="login-form_Sub-title mb-3">Enter your User Id</div>
      <div className="mb-3 flex-1">
        <AppTextInput
          required
          name="userId"
          id="userId"
          label={<FormattedMessage id="user_id_placeholder" />}
          errorText={validationError && 'Please enter User ID'}
          className="login-form--app-input"
          onChange={(e) => setUserId(e.target.value)}
          value={userId}
        />
      </div>
      <AppLink
        className="mb-3 fw-500 fs-14 text-end"
        variant="primary"
        onClick={() => onShowForm('login')}
        linkText={<FormattedMessage id="back_to_login" />}
      />
      <AppButton
        btnText={<FormattedMessage id="submit_btn" />}
        btnType="submit"
        variant="primary"
        onClick={handleSubmit}
      />
    </form>
  );
}

ForgotPassword.propTypes = {
  onShowForm: PropTypes.func.isRequired,
  onLoading: PropTypes.func.isRequired,
  onAlert: PropTypes.func.isRequired,
};

export default ForgotPassword;
